(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-custom"] && !Shopify.designMode) return;
  try {
    
  const dynamicaccordiontoggle = document.querySelector('button.DynamicAccordion_Tab_Footer');
  const dynamicaccordioncontainer = document.querySelector('.DynamicAccordion_Tab_Details');
  if( dynamicaccordiontoggle) {
      dynamicaccordiontoggle.addEventListener("click", event => {
        const dynamicaccordioncontainer = document.querySelector('.DynamicAccordion_Tab_Details');
        if(dynamicaccordioncontainer) { 
          dynamicaccordioncontainer.classList.toggle('active');
        }
        event.target.closest('button').classList.toggle('active');
      })
  }

  } catch(e) { console.error(e); }
})();
})();
